/* eslint-disable @next/next/no-img-element */
import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import styles from "./styles.module.scss";

type ModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
};

const Modal = ({ open, onClose, title, content }: ModalProps) => {
  useEffect(() => {
    if (open) {
      window.document.body.style.overflow = "hidden";
    } else {
      window.document.body.style.overflow = "auto";
    }
  }, [open]);

  if (!open) return null;

  return (
    <div className="overlay dark">
      <div className={styles.modal}>
        <div className={styles["modal-header"]}>
          <div className="heading-xs">{title}</div>
          <FontAwesomeIcon
            className="link-icon-left"
            icon={faXmark}
            fontSize={40}
            style={{
              color: "var(--token-colors-neutral-lnk-light)",
              cursor: "pointer"
            }}
            onClick={() => onClose()}
          />
        </div>
        <div className={styles["modal-content"]}>{content}</div>
      </div>
    </div>
  );
};

export default Modal;
